import React, { useContext } from 'react';
import { CheckCircleOutlined, StopOutlined } from '@ant-design/icons';
import { Button, Col, Input, Row } from 'antd';
import dayjs from 'dayjs';

import OptimizeDeferralButton from '@totem/components/ticketing/details/optimize/optimizeDeferralButton';
import TicketContext from '@totem/components/ticketing/details/ticketContext';
import { SelectedApprovals } from '@totem/components/ticketing/ticketing';
import HeaderItem from '@totem/components/ui_components/headers/HeaderItem';
import { isNotNull } from '@totem/utilities/common';
const { TextArea } = Input;

type Props = {
  approval: SelectedApprovals;
  onUpdate: (approval: SelectedApprovals) => void;
};

const ApprovalItem = ({ approval, onUpdate }: Props) => {
  const [reason, setReason] = React.useState<string>('');
  const { ticket } = useContext(TicketContext);

  const handleApprove = () => {
    const update: SelectedApprovals = {
      approvalRequest: approval.approvalRequest,
      approval: {
        ...approval.approval,
        status: 'APPROVED',
        reason,
        outcomeAt: dayjs().toISOString(),
      },
    };
    onUpdate(update);
  };

  const handleReject = () => {
    const update: SelectedApprovals = {
      approvalRequest: approval.approvalRequest,
      approval: {
        ...approval.approval,
        status: 'REJECTED',
        reason,
        outcomeAt: dayjs().toISOString(),
      },
    };
    onUpdate(update);
  };

  const getDeferralMessage = () => {
    if (
      isNotNull(ticket.ticket) &&
      isNotNull(ticket.ticket.extras) &&
      isNotNull(ticket.ticket.extras.optimize) &&
      ticket.ticket.extras.optimize.opportunityStatus === 'Deferred'
    ) {
      if (ticket.ticket.extras.optimize.deferredUntil !== '') {
        const deferralDate = dayjs(ticket.ticket.extras.optimize.deferredUntil);
        if (deferralDate.year() > 2000) {
          return (
            <b style={{ marginLeft: '16px' }}>
              {' '}
              DEFERRED until {deferralDate.format('YYYY-MM-DD')}
            </b>
          );
        }
      }

      return <span> (DEFERRED)</span>;
    }
    return <span />;
  };

  return (
    <div style={{ borderBottom: '1px solid #ddd' }}>
      <Row>
        <Col span={16}>
          <HeaderItem title="Summary">
            {approval.approvalRequest.summary}
          </HeaderItem>
          <HeaderItem title="Description">
            {approval.approvalRequest.description}
          </HeaderItem>
        </Col>
        <Col span={8}>
          <HeaderItem title="Reason (if rejected)">
            <TextArea
              onChange={(evt) => setReason(evt.target.value)}
              value={reason}
            />
          </HeaderItem>
          <br />
          <Button
            type={'primary'}
            onClick={handleApprove}
            icon={<CheckCircleOutlined />}
          >
            Approve
          </Button>
          <Button
            onClick={handleReject}
            style={{ marginLeft: '16px' }}
            icon={<StopOutlined />}
          >
            Reject
          </Button>
          {isNotNull(ticket.ticket?.extras?.optimize?.opportunityStatus) && (
            <>
              <OptimizeDeferralButton style={{ marginLeft: '16px' }} />
              {getDeferralMessage()}
            </>
          )}
        </Col>
      </Row>
      <br />
    </div>
  );
};

export default ApprovalItem;
